import { ThemeUICSSObject } from '@apia/theme';
import history from './history';
/* IMPORT HERE */

const processes: ThemeUICSSObject = {
  history,
  /* PREPEND HERE */
};

export default processes;
